import practicalTraining from './components/practicalTraining.vue';

export default {
    routes: [
        {
            path: '/',
            component: practicalTraining,
            name: 'practicalTraining'
        },

    ]
};